import { createContext, useState, useEffect } from "react";
import api from "../services/api.js"; // تأكد من المسار الصحيح

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true); // Loading state

  const fetchUser = async () => {
    try {
      const res = await api.get("/users/me");
      setUser(res.data?.data);
    } catch (err) {
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUser();
  }, []);

  return (
    <AuthContext.Provider value={{ user, setUser, loading, fetchUser }}>
      {children}
    </AuthContext.Provider>
  ); // user, setUser, loading
};

// // context/AuthContext.js
// import { createContext, useContext, useState, useEffect, useCallback } from "react";
// import { getUser } from "../services/userService";
// import { login } from "../services/authService";
// import api from "../services/api";

// const AuthContext = createContext();

// export const AuthProvider = ({ children }) => {
//   const [user, setUser] = useState(null);
//   const [loading, setLoading] = useState(true);

//   const logoutUser = useCallback(async (flag) => {
//     try {
//       await api.post("/Auth/logout");
//       setUser(null);
//       return { success: true };
//     } catch {
//       return { success: false };
//     }
//   }, []);

//   const loginUser = async (email, password) => {
//     try {
//       const response = await login(email, password);
//       console.log("Resposne: ", response);

//       setUser(response.data || response.data?.data);
//       return { success: true };
//     } catch (error) {
//       return { success: false, error: error.message };
//     }
//   };

//   const refreshToken = useCallback(async () => {
//     try {
//       await api.get("/Auth/refresh", { withCredentials: true });
//       return true;
//     } catch (err) {
//       await logoutUser();
//       return false;
//     }
//   }, [logoutUser]);

//   useEffect(() => {
//     const fetchUser = async () => {
//       try {
//         const data = await getUser();
//         setUser(data.data || data.data?.data);
//       } catch (error) {
//         if (error.response?.status === 401) {
//           const refreshed = await refreshToken();
//           if (refreshed) {
//             try {
//               const data = await getUser();
//               setUser(data.data || data.data?.data);
//             } catch {
//               setUser(null);
//             }
//           } else {
//             setUser(null);
//           }
//         } else {
//           setUser(null);
//         }
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchUser();
//   }, [refreshToken]);

//   return (
//     <AuthContext.Provider value={{ user, setUser, loading, loginUser, logoutUser, refreshToken }}>
//       {children}
//     </AuthContext.Provider>
//   );
// };

// export const useAuth = () => useContext(AuthContext);
